module.exports = __webpack_public_path__ + "static/media/20200506-4.190a066b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/banner/20200506/img/20200506-4.jpg
// module id = 319
// module chunks = 0